export const Loader = ()=>{
    return 'loading...'
}